import React from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TrainingHeaderProps } from './Types';
import CustomHeader from '../CustomHeader';
import CommonButton from '../../common/CommonButton';
import {
  getHeaderLevel,
  getTextAlignmentClass,
} from '../../../services/generalUtils';
import { toAgilityButtonStyle } from '../../../services/agilityDataUtils';

const TrainingHeader = ({
  backgroundStyle,
  title,
  titleStyle,
  subTitle,
  subTitleStyle,
  numberOfDays,
  numberOfDaysStyle,
  includedButtonLabel,
  includedButtonStyle,
  expanded,
  onToggle,
}: TrainingHeaderProps) => {
  return (
    <div
      className={`text-white p-10 h-auto w-full md:w-auto md:h-auto lg:max-w-[1332px] lg:min-h-[122px] lg:h-[122px] ${expanded ? 'rounded-t-lg' : 'rounded-lg'}`}
      style={{ backgroundColor: backgroundStyle?.color || '#00557E' }}
    >
      <div className="flex flex-col lg:flex-row md:justify-between md:items-center h-full w-full">
        <div className="w-full md:w-auto mb-4 md:mb-0 pt-[10px]">
          <CustomHeader
            text={title}
            headerStyle={{
              color: titleStyle?.color,
              level: getHeaderLevel(titleStyle?.level),
              alignment: getTextAlignmentClass(titleStyle?.alignment, 'left'),
              className:
                "font-['Source_Sans_3'] font-semibold text-[26px] leading-[24px] uppercase lg:text-[26px] lg:leading-[24px] lg:font-semibold",
            }}
          />
          <p
            className={`font-['Source_Sans_3'] font-normal not-italic capitalize text-[13px] leading-[19px] lg:text-[15px] lg:leading-[21px] max-w-[579px] mb-4 pt-[10px] ${getTextAlignmentClass(
              subTitleStyle?.alignment || subTitleStyle?.textAlignment,
              'left',
            )}`}
            style={{ ...subTitleStyle } as React.CSSProperties}
          >
            {subTitle}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center md:mx-8 mb-4 md:mb-0">
          <p
            className="font-['Source_Sans_3'] font-semibold not-italic capitalize text-[32px] leading-[24px] text-center lg:text-[26px] lg:leading-[24px] lg:text-left"
            style={numberOfDaysStyle}
          >
            {numberOfDays}
          </p>
        </div>
        <div className="flex items-center gap-4 w-full md:w-auto md:ml-8">
          <CommonButton
            text={includedButtonLabel}
            buttonStyle={
              includedButtonStyle
                ? toAgilityButtonStyle(includedButtonStyle)
                : undefined
            }
            onClick={onToggle}
            endIcon={
              expanded ? (
                <ExpandLessIcon
                  className="w-full h-full"
                  style={
                    includedButtonStyle?.textColor
                      ? { color: includedButtonStyle.textColor }
                      : {}
                  }
                />
              ) : (
                <ExpandMoreIcon
                  className="w-full h-full"
                  style={
                    includedButtonStyle?.textColor
                      ? { color: includedButtonStyle.textColor }
                      : {}
                  }
                />
              )
            }
            size="md"
          />
        </div>
      </div>
    </div>
  );
};

export default TrainingHeader;
